import FirebaseConfig from '../helpers/FirebaseConfig.js';
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

let booking = (localStorage.getItem("selectedDepartment") == 'TopTracer') ? 'teeSheetTT.vue' : 'teeSheet.vue';
Vue.use(Router)

const router = new Router({
  mode: process.env.IS_ELECTRON ? 'hash' : 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/login/:tenant?',
      name: 'login',
      meta: { publicRouter: true },
      component: () => import('../components/Login/Loginv2.vue'),
    },
    {
      path: '/chat',
      meta: { publicRouter: true, type: "chat" },
      component: () => import('../components/chat.vue'),
    },
    {
      path: '/reservar_transportacion/puerto_cancun',
      meta: { publicRouter: true, type: "chat" },
      component: () => import('../components/transportacion.vue')
    },
    {
      path: '/dinamics/:fecha/:producto',
      meta: { publicRouter: true },
      component: () => import('../components/Restaurante/DinamicReward/DinamicReward.vue')
    },
    {
      path: '/',
      name: 'landing-page',
      props: { type: 'mainMenu' },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: '',
          name: 'admin_home',
          meta: { admin: true },
          component: () => import('../components/Home/Home.vue'),
        },
        {
          path: 'testing-component',
          name: 'admin_test_component',
          meta: { admin: true },
          component: () => import('../components/MainComponents/test_component.vue'),
        },
        {
          path: 'booking',
          name: 'admin_reservas',
          meta: { admin: true },
          component: () => import('../components/Reservas/teeSheet.vue'),
        },
        {
          path: 'starter',
          name: 'admin_reservas_starter',
          meta: { admin: true },
          component: () => import('../components/Reservas/Starter.vue'),
        },
        {
          path: 'actividades',
          name: 'admin_actividadesV2',
          meta: { admin: true },
          component: () => import('../components/Reservas/Actividades/TeeSheetActivity.vue'),
        },
        {
          path: 'actividadesV2',
          name: 'admin_actividades',
          meta: { admin: true },
          component: () => import('../components/Reservas/ActividadesV2/TeeSheetActivityV2.vue'),
        },
        {
          path: 'bookingMayorista',
          name: 'mayorista_reservas',
          meta: { admin: true },
          component: () => import('../components/Afiliados/Reservas/reserva.vue'),
        },
        {
          path: 'bookingReservaTopTracerMayorista',
          name: 'mayorista_reservasTop',
          meta: { admin: true },
          component: () => import('../components/Afiliados/Reservas/ReservaTopTracerAfiliado.vue'),
        },
        {
          path: 'userMayorista',
          name: 'mayorista_usuarios',
          meta: { admin: true },
          component: () => import('../components/Afiliados/UsuariosAfiliados/UsuarioAfiliado.vue'),
        },
        {
          path: 'list_reserva',
          name: 'admin_list',
          meta: { admin: true },
          component: () => import('../components/Reportes/listReserva.vue'),
        },
        {
          path: 'rondas-prepago',
          name: 'ronda-prepago',
          meta: { admin: true },
          props: { series: true },
          component: () => import('../components/Afiliados/Cupones/CuponesCRUD.vue'),

        },
        {
          path: 'security-filter',
          name: 'security-filter',
          meta: { admin: true },
          props: { series: true },
          component: () => import('../components/FiltroSeguridad/SecurityFilter.vue'),

        },
      ]
    },
    {
      path: '/usuarios_admin',
      name: 'landingUsuarios',
      props: { type: 'usuarios' },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: 'cajeros',
          name: 'admin_cajeros',
          meta: { admin: true },
          component: () => import('../components/Usuarios/Cajeros/CajerosCrud.vue'),
        },
        {
          path: 'administrativos',
          name: 'admin_usuarios',
          meta: { admin: true },
          component: () => import('../components/Usuarios/UsuariosAdmin/UsuariosAdminCRUD.vue'),
        },
      ]
    },
    {
      path: '/cajas',
      name: '',
      meta: { admin: true },
      props: { series: true },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: '/',
          name: 'admin_instalaciones',
          meta: { admin: true },
          component: () => import('../components/Cajas/InstalacionesCrud.vue'),
        },
        {
          path: 'cajaDetail/:idInstalacion',
          name: 'admin_cajaDetail',
          meta: { admin: true },
          component: () => import('../components/Cajas/CajaCrud.vue'),
        },
        {
          path: 'cortes',
          name: 'admin_cortesList',
          meta: { admin: true },
          component: () => import('../components/Cajas/CortesList.vue'),
        },
      ]
    },
    /* Restaurante */
    {
      path: '/restaurante',
      name: 'restaurante',
      props: { type: 'restaurante' },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: 'departamentos',
          name: 'restauranteDepartamentos',
          meta: { admin: true },
          component: () => import('../components/Restaurante/DepartamentoCRUD.vue'),
        },
        {
          path: 'areas/:idDepartamento',
          name: 'restauranteAreas',
          meta: { admin: true },
          component: () => import('../components/Restaurante/DepartamentoAreaEditor.vue'),
        },
        {
          path: 'galeria/:idDepartamento',
          name: 'galeriaEditor',
          meta: { admin: true },
          component: () => import('../components/Restaurante/DepartamentoGaleriaEditor.vue'),
        },
        {
          path: 'meseros',
          name: 'restauranteMeseros',
          meta: { admin: true },
          component: () => import('../components/Restaurante/Meseros/MeserosCRUD.vue'),
        },
        {
          path: 'cuentas',
          name: 'restauranteCuentas',
          meta: { admin: true },
          component: () => import('../components/Restaurante/Cuentas/CuentasAYB.vue'),
        },
        {
          path: 'reservas',
          name: 'restauranteReservas',
          meta: { admin: true },
          component: () => import('../components/Restaurante/BookingTable/BookingTable.vue'),
        },
        {
          path: 'monederos-fb',
          name: 'restauranteMonederos',
          meta: { admin: true },
          component: () => import('../components/Restaurante/RestauranteMonederos/MonederosRestaurante.vue'),
        },
        {
          path: 'productos-ayb',
          name: 'productosAYB',
          meta: { admin: true },
          component: () => import('../components/Restaurante/ProductosAYB/ProductosAYBCrud.vue'),
        },
        {
          path: 'insumos-ayb',
          name: 'insumosAYB',
          meta: { admin: true },
          component: () => import('../components/Restaurante/Insumos/InsumosCrud.vue'),
        },
        {
          path: 'insumosC-ayb',
          name: 'insumosCAYB',
          meta: { admin: true },
          component: () => import('../components/Restaurante/InsumosElaborados/InsumosCompuestosCrud.vue'),
        },
        {
          path: 'produccion-ayb',
          name: 'insumosProdAYB',
          meta: { admin: true },
          component: () => import('../components/Restaurante/Produccion/ProduccionAYB.vue'),
        },
        {
          path: 'menu-grouper',
          name: 'menuAYB',
          meta: { admin: true },
          component: () => import('../components/Restaurante/DigitalMenuGrouper/MenuGrouperCreator.vue'),
        },
        {
          path: "menus-comandero",
          name: "menusComandero",
          meta: { admin: true },
          component: () => import('../components/Restaurante/MenusComandero/MenusComandero.vue'),
        },
        {
          path: 'traduccion-productos',
          name: 'tradProdAYB',
          meta: { admin: true },
          component: () => import('../components/Restaurante/TraducciónProductosAYB/TraduccionCRUD.vue')
        },
        {
          path: 'mesas-cuentas',
          name: 'mesasCuentas',
          meta: { admin: true },
          component: () => import('../components/Restaurante/MesasCuentas.vue')
        },
        {
          path: 'eventos',
          name: 'eventos',
          meta: { admin: true },
          component: () => import('../components/Restaurante/Eventos/Eventos.vue')
        },
        {
          path: 'paquetes',
          name: 'paquetes_ayb',
          meta: { admin: true },
          component: () => import('../components/Restaurante/PaquetesRestaurante/Paquetes.vue')
        },
      ],
    },
    {
      path: '/credito',
      name: 'credito',
      props: { type: 'credito' },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: 'lineas',
          name: 'credito-lineas',
          meta: { admin: true },
          component: () => import('../components/LineasCredito/CreditoCRUD.vue'),
        },
        {
          path: 'detail/:idLineaCredito',
          name: 'credito-detail',
          meta: { admin: true },
          component: () => import('../components/LineasCredito/CreditoDetail.vue'),
        },
        {
          path: 'tipos-lineas',
          name: 'tipos-lineas',
          meta: { admin: true },
          component: () => import('../components/LineasCredito/TiposCredito/TiposCreditoCRUD.vue'),
        },
      ]
    },
    {
      path: '/creditbook',
      name: 'creditbook-old',
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: 'types',
          name: 'cb-types',
          meta: { admin: true },
          component: () => import('../components/CreditBooksType/CreditBooksType.vue'),
        },
      ]
    },
    /* membresias */
    {
      path: '/membresias',
      name: 'membresias',
      props: { type: 'membresias' },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: 'planes',
          name: 'membresiaPlanesList',
          meta: { admin: true },
          component: () => import('../components/Membresias/PlanMembresias.vue'),
        },
        /*{
          path: 'creditbook',
          name: 'creditbook',
          meta: { admin: true },
          component: () => import('../components/Membresias/CreditBook/CreditBook.vue'),
        },*/
        {
          path: 'migrar-plan',
          name: 'migradorplanes',
          meta: { admin: true },
          component: () => import('../components/Membresias/MigradorMembresias/MigradorMembresias.vue'),
        },
        {
          path: 'creditbook',
          name: 'creditbook',
          meta: { admin: true },
          component: () => import('../components/Membresias/CreditBook/CreditBook.vue'),
        },
        {
          path: 'paquetes',
          name: 'paquetes',
          meta: { admin: true },
          component: () => import('../components/Membresias/Paquetes/PaquetesCRUD.vue'),
        },

        {
          path: 'listadoMembresias',
          name: 'membresiaList',
          meta: { admin: true },
          component: () => import('../components/Membresias/Membresias/MembresiasCRUD.vue'),
        },
        {
          path: 'detalleMembresias/:idMembresia?',
          name: "membresiaDetalle",
          meta: { admin: true },
          component: () => import('../components/Membresias/Membresias/DetalleMembresia.vue'),
        },
        {
          path: 'beneficios/:idPlan?',
          name: 'membresiaBeneficios',
          meta: { admin: true },
          component: () => import('../components/Membresias/Beneficios/Beneficios.vue'),
        },
        {
          path: 'periodos-cobro',
          name: 'membresiaPeriodos',
          meta: { admin: true },
          component: () => import('../components/Membresias/PeriodosPago/PeriodoPagoCRUD.vue'),
        },
        {
          path: 'conceptos',
          name: 'membresiaConceptos',
          meta: { admin: true },
          component: () => import('../components/Membresias/Conceptos/ConceptosCRUD.vue'),
        },
        {
          path: 'miembros',
          name: 'miembro',
          meta: { admin: true },
          component: () => import('../components/Membresias/Miembros.vue'),
        },
        {
          path: 'movimientos',
          name: 'reporte_movimientos_membresia',
          meta: { admin: true },
          component: () => import('../components/Membresias/ReporteMovimientos.vue'),
        },
        {
          path: 'reporte-planes',
          name: 'reporte-planes_membresia',
          meta: { admin: true },
          component: () => import('../components/Membresias/ReportePlanes.vue'),
        },
        {
          path: 'planes-mbr',
          name: 'planes_mbr',
          meta: { admin: true },
          component: () => import('../components/Membresias/Planes/Planes.vue'),
        },
        {
          path: 'load-movimientos',
          name: 'cargaMovimientos',
          meta: { admin: true },
          component: () => import('../components/Membresias/Movimientos/loadMovimientos.vue'),
        },
        {
          path: 'security-filter',
          name: 'security-filter-membresias',
          meta: { admin: true },
          props: { series: true },
          component: () => import('../components/FiltroSeguridad/SecurityFilter.vue'),
        },
      ]
    },
    /* Transportacion */
    {
      path: '/transportacion',
      props: { type: 'transportistas' },
      meta: { admin: true },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: 'manifiesto/',
          name: 'transportista',
          meta: { admin: true },
          component: () => import('../components/Transportacion/ManifiestoTransportacion.vue'),
        },
      ],
    },
    /* Importador */
    {
      path: '/importador',
      props: { type: 'importador' },
      meta: { admin: true },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: '/',
          name: 'importadormain',
          meta: { admin: true },
          component: () => import('../components/Importador/Importador.vue'),
        },
      ],
    },
    /* Tools */
    {
      path: '/tools',
      name: 'tools',
      props: { type: 'tools' },
      meta: { admin: true },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: "export-ticket",
          name: 'export-ticket',
          meta: { admin: true },
          component: () => import('../components/Tools/Tickets/ExportTickets.vue'),
        },
        {
          path: "editorventas",
          name: 'editor-ventas',
          meta: { admin: true },
          component: () => import('../components/Tools/EditorVentas/EditorVentas.vue'),
        },

        {
          path: "campanas-whatsapp",
          name: 'campanas-whatsapp',
          meta: { admin: true },
          component: () => import('../components/Tools/CampañasWhatsapp/CampañasWhatsapp.vue'),
        },
        {
          path: "campanas-mkt",
          name: 'campanas-mkt',
          meta: { admin: true },
          component: () => import('../components/Tools/CampañasMKT/CampanasCupones.vue'),
        },
        {
          path: "migradorVentas",
          name: 'migrador-ventas',
          meta: { admin: true },
          component: () => import('../components/Tools/MigradorVentas/MigradorVentas.vue'),
        },
        {
          path: "cron-editor",
          name: 'cron-editor',
          meta: { admin: true },
          component: () => import('../components/Tools/CronRulesEditor/RulesAvailability.vue'),
        },
        {
          path: "export-ticketContabilidad",
          name: 'export-ticketContabilidad',
          meta: { admin: true },
          component: () => import('../components/Tools/Tickets/ExportTicketsContabilidad.vue'),
        },
        {
          path: "logger",
          name: 'logger',
          meta: { admin: true },
          component: () => import('../components/Tools/BigQueryLogger/LoggerView.vue'),
        }
      ],
    },
    /* Reportes */
    {
      path: '/reportes',
      name: 'repor',
      props: { type: 'reportes' },
      meta: { admin: true },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: 'general',
          name: 'reporteGeneral',
          meta: { admin: true },
          component: () => import('../components/Reportes/ReporteGeneral.vue'),
        },
        {
          path: 'reserva',
          name: 'reporte_reserva',
          meta: { admin: true },
          component: () => import('../components/Reportes/reservacionesRepo.vue'),
        },
        {
          path: 'productos_ventas',
          name: 'reporte_rprod',
          meta: { admin: true },
          component: () => import('../components/Reportes/ventaProducto.vue'),
        },
        {
          path: 'producto_tprom',
          name: 'reporte_tpromprod',
          meta: { admin: true },
          component: () => import('../components/Reportes/TicketPromedioProducto.vue'),
        },
        {
          path: 'actividades',
          name: 'reporte_actividades',
          meta: { admin: true },
          component: () => import('../components/Reportes/Actividades/ReporteActividades.vue'),
        },
        {
          path: 'monederos',
          name: 'reporte_monederos',
          meta: { admin: true },
          component: () => import('../components/Reportes/Monederos/ReporteMonederos.vue'),
        },
        {
          path: 'productos_utilidad_ventas',
          name: 'reporte_utilidad_prod',
          meta: { admin: true },
          component: () => import('../components/Reportes/UtilidadProducto.vue'),
        },
        {
          path: 'modificadores_ventas',
          name: 'reporte_modificadores',
          meta: { admin: true },
          component: () => import('../components/Reportes/VentasModificador.vue'),
        },
        {
          path: 'rondas_vendidas',
          name: 'reporte_rondas',
          meta: { admin: true },
          component: () => import('../components/Reportes/RondasVendidas.vue'),
        },
        {
          path: 'ticket_promedio',
          name: 'reporte_ticket-promedio',
          meta: { admin: true },
          component: () => import('../components/Reportes/Restaurante/ReporteTicketPromedio.vue'),
        },
        {
          path: 'descuentos',
          name: 'reporte_descuentos',
          meta: { admin: true },
          component: () => import('../components/Reportes/Descuentos/ReporteDescuentos.vue'),
        },
        {
          path: 'reportez',
          name: 'reporte_z',
          meta: { admin: true },
          component: () => import('../components/Reportes/ReporteZ.vue'),
        },
        {
          path: 'transportacion',
          name: 'reporte_transportacion',
          meta: { admin: true },
          component: () => import('../components/Reportes/reservacionesTrans.vue'),
        },
        {
          path: 'ventas',
          name: 'reporte_ventas',
          meta: { admin: true },
          component: () => import('../components/Reportes/ReporteVentas.vue'),
        },
        {
          path: 'reporte-transacciones',
          name: 'proshop_reportTrnas',
          component: () => import('../components/Reportes/ReporteTransacciones.vue'),
        },
        {
          path: 'reporte-propinas',
          name: 'proshop_propinas',
          component: () => import('../components/Reportes/ReportePropinas.vue'),
        },
        {
          path: 'reporte-meseros',
          name: 'reporte-meseros',
          component: () => import('../components/Reportes/ReporteMeseros.vue'),
        },
        {
          path: 'reporte-pagos-propinas',
          name: 'pagos-propinas',
          component: () => import('../components/Reportes/Restaurante/ReportePagosPropina.vue'),
        },
        {
          path: 'reporte-cxc',
          name: 'reporte-cxc',
          component: () => import('../components/Reportes/CuentasxCobrar/ReporteCxC.vue'),
        },
        {
          path: 'reporte-entradasysalidas',
          name: 'reporte-entradasysalidas',
          component: () => import('../components/Reportes/ReporteEntradasSalidas.vue'),
        },
        {
          path: 'reporteocupacion',
          name: 'reporteocupacion',
          component: () => import('../components/Reportes/reporteOcupacionCampo.vue')
        },
        {
          path: 'rondasprepagadas',
          name: 'reporte-rondasprepagadas',
          component: () => import('../components/Reportes/ReporteRondasPrepagadas.vue')
        },
        {
          path: 'reportetarifas',
          name: 'reporte-tarifas',
          component: () => import('../components/Reportes/ReporteTarifas.vue')
        },
        {
          path: 'valoracion-inventario',
          name: 'valoracion-inventario',
          component: () => import('../components/Reportes/ValoracionInventario.vue')
        },
        {
          path: 'comensales',
          name: 'reporte-comensales',
          component: () => import('../components/Reportes/Comensales/ReporteComensales.vue')
        },
        {
          path: 'ventasInsumos',
          name: 'reporte-ventaInsumos',
          component: () => import('../components/Reportes/VentasInsumo.vue')
        },
        {
          path: 'venta-productos-hora',
          name: 'reporte-ventaProductoHora',
          component: () => import('../components/Reportes/Restaurante/ReporteVentaProductosHora.vue')
        },
        {
          path: 'transacionesContabilidad',
          name: 'transacciones-contabilidad',
          component: () => import('../components/ReportesContabilidad/ReporteTransaccionesContabilidad.vue')
        },
        {
          path: 'reporteZContabilidad',
          name: 'reportez-contabilidad',
          component: () => import('../components/ReportesContabilidad/ReporteZContabilidad.vue')
        },
        {
          path: 'cxc-ingresos',
          name: 'cxc-ingresos',
          component: () => import('../components/Reportes/CuentasxCobrar/CXCLog.vue')
        }
      ]
    },
    {
      path: '/clientes',
      meta: { admin: true },
      props: { type: 'Clientes' },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: '/',
          name: 'main_clientes',
          meta: { admin: true },
          component: () => import('../components/Clientes/Clientes/ClientesCRUD.vue'),
        },
        {
          path: 'grupos_cliente',
          name: 'grupos_clientes',
          meta: { admin: true },
          component: () => import('../components/Clientes/GruposClientes/GruposClientesCRUD.vue'),
        },
        {
          path: 'lista_cliente',
          name: 'admin_clientes',
          meta: { admin: true },
          component: () => import('../components/Clientes/Clientes/ClientesCRUD.vue'),
        },
        {
          path: 'cuentas',
          name: 'admin_cuentas',
          meta: { admin: true },
          component: () => import('../components/Clientes/Cuentas/CuentaCRUD.vue'),
        },
        {
          path: 'monedero',
          name: 'admin_monedero',
          meta: { admin: true },
          component: () => import('../components/Clientes/Monedero/MonederoCRUD'),
        },
        {
          path: 'clientesCrisp',
          name: 'clientes_crisp',
          meta: { admin: true },
          component: () => import('../components/Clientes/Clientes/ClientesCrisp'),
        }
      ],
    },
    /* Configuracion */
    {
      path: '/configuracion',
      meta: { admin: true },
      props: { type: 'configuraciones' },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: '/',
          name: 'config',
          meta: { admin: true },
          component: () => import('../components/Configuracion/configApp.vue'),
        },
        {
          path: 'reservas',
          name: 'config_general_reserva',
          meta: { admin: true },
          component: () => import('../components/Configuracion/ConfigReservas.vue'),
        },
        {
          path: 'general',
          name: 'config_general',
          meta: { admin: true },
          component: () => import('../components/Configuracion/configApp.vue'),
        },
        {
          path: 'dispositivos-biometricos',
          name: '',
          meta: { admin: true },
          component: () => import('../components/Configuracion/ConfigBiometrico/BiometricosCRUD.vue')
        },
        {
          path: 'roles',
          name: 'roles',
          meta: { admin: true, id: "CONF_ROLES" },
          component: () => import('../components/Roles/RolesCRUD.vue'),
        },
        {
          path: 'departamentos',
          name: 'config_departamentos',
          meta: { admin: true },
          component: () => import('../components/Configuracion/ConfigDepartamentos.vue'),
        },
        {
          path: 'metodos_Pago',
          name: 'config_pagos',
          meta: { admin: true },
          component: () => import('../components/Configuracion/MetodosPago/MetodosPagoCRUD.vue'),
        },
        {
          path: 'bahias',
          name: 'config_bahias',
          meta: { admin: true },
          component: () => import('../components/Configuracion/Bahias/BahiasCRUD.vue'),
        },
        {
          path: 'creador_actividades',
          name: 'creador_actividades',
          meta: { admin: true },
          component: () => import('../components/Configuracion/CreadorActividades/CreadorActividadesCRUD.vue'),
        },
        {
          path: 'claves_admin',
          name: 'claves_admin',
          meta: { admin: true },
          component: () => import('../components/Configuracion/ClavesAdministradores/ClavesAdminCRUD.vue'),
        },
        {
          path: 'tiposcambios',
          name: 'config_tiposcambios',
          meta: { admin: true },
          component: () => import('../components/Configuracion/ConfigTiposCambios.vue'),
        },
        {
          path: 'dias',
          name: 'config_dias',
          meta: { admin: true },
          component: () => import('../components/Configuracion/ConfigDays'),
        },
        {
          path: 'horas',
          name: 'config_horas',
          meta: { admin: true },
          component: () => import('../components/Configuracion/ConfigTimes.vue'),
        },
        {
          path: 'smtp',
          name: 'config_smtp',
          meta: { admin: true },
          component: () => import('../components/Configuracion/ConfigSMTP'),
        },
        {
          path: "apps",
          name: "apps",
          meta: { admin: true },
          component: () => import('../components/Configuracion/AppsConfig/AppsConfigCrud.vue'),
        },
        {
          path: "zonas-seguridad",
          name: 'zonas-seguridad',
          meta: { admin: true },
          component: () => import('../components/Tools/ZonasSeguridad/ZonasSeguridad.vue'),
        },
        {
          path: "puertas-acceso",
          name: 'puertas-acceso',
          meta: { admin: true },
          component: () => import('../components/Tools/PuertasAcceso/PuertasAcceso.vue'),
        },
      ]
    },
    /* Documentación */
    {
      path: '/documentacion',
      props: { type: 'Documentacion' },
      meta: { admin: true },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: '/',
          name: 'documentacion',
          meta: { admin: true },
          component: () => import('../components/Documentacion/DocumentacionIframe.vue'),
        },
      ]
    },
    /* Conectar asistente de IA (MCP) */
    {
      path: '/asistente-ia',
      props: { type: 'AsistenteIA' },
      meta: { admin: true },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: '/',
          name: 'asistente-ia',
          meta: { admin: true },
          component: () => import('../components/AI/ConectarAsistente.vue'),
        },
      ]
    },
    /* Tarifas */
    {
      path: '/tarifas',
      props: { type: 'Tarifas' },
      meta: { admin: true },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: '/',
          name: 'create',
          meta: { admin: true },
          component: () => import('../components/Tarifas/Tarifas/Tarifas.vue'),
        },
        {
          path: 'creator',
          name: 'create_tarifas',
          meta: { admin: true },
          component: () => import('../components/Tarifas/Tarifas/Tarifas.vue'),
        },
        {
          path: 'subcategorias',
          name: 'subcategorias_tarifas',
          meta: { admin: true },
          component: () => import('../components/Tarifas/Subcategorias/SubCategoriaCRUD.vue'),
        },
        {
          path: 'horarios',
          name: 'horario_tarifas',
          meta: { admin: true },
          component: () => import('../components/Tarifas/Horarios/HorarioCRUD.vue'),
        },
        {
          path: 'timesCreator/:idDocument?',
          name: 'times_creator',
          meta: { admin: true },
          component: () => import('../components/Tarifas/ActivityTimesCreator/TimesCreator.vue'),
        },
        {
          path: 'paquetesCreator',
          name: 'paquetes_creator',
          meta: { admin: true },
          component: () => import('../components/TarifasActividades/PaquetesPrecio/PaquetesPrecioCRUD.vue'),
        },
        {
          path: 'temporadas',
          name: 'temporads_tarifas',
          meta: { admin: true },
          component: () => import('../components/Tarifas/Temporadas/TemporadasCRUD.vue'),
        },
        {
          path: 'tarifarios',
          name: 'tarifarios',
          meta: { admin: true },
          component: () => import('../components/Tarifas/Tarifarios/tarifariosCRUD.vue'),
        },
        {
          path: 'mercados',
          name: 'mercados_tarifas',
          meta: { admin: true },
          component: () => import('../components/Tarifas/Mercados/MercadosCrud.vue'),
        },
      ],
    },
    {
      path: '/mayoristas',
      meta: { admin: true },
      props: { type: 'Mayoristas' },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: '/',
          name: 'afiliados',
          meta: { admin: true },
          component: () => import('../components/Afiliados/MayoristasCRUD.vue'),
        },
        {
          path: 'concierges',
          name: 'concierges',
          meta: { admin: true },
          component: () => import('../components/Concierges/ConciergesCRUD.vue'),
        },
        {
          path: 'usuarios',
          name: 'admin_afiliados_usuarios',
          meta: { admin: true },
          component: () => import('../components/Afiliados/usuarios.vue'),
        },
        {
          path: 'transportacion',
          name: 'admin_afiliados_transportacion',
          meta: { admin: true },
          component: () => import('../components/Afiliados/CostosTransportacion/CostoTransportacion.vue'),
        },
        {
          path: 'cupones',
          name: 'admin_afiliados_cupones',
          meta: { admin: true },
          component: () => import('../components/Afiliados/Cupones/CuponesCRUD.vue'),
        },
      ]
    },
    /* inventario */
    {
      path: '/productos-inventarios',
      name: 'inventarios',
      meta: { admin: true },
      props: { type: 'inventarios' },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: 'cron-editor',
          name: 'cron_editor',
          meta: { admin: true },
          component: () => import('../components/Tools/CronRulesEditor/CronRulesEditor.vue'),
        },
        {
          path: 'familias',
          name: 'admin_familias',
          meta: { admin: true },
          component: () => import('../components/Inventarios/Familias/FamiliasCRUD.vue'),
        },
        {
          path: 'categorias',
          name: 'admin_categorias',
          meta: { admin: true },
          component: () => import('../components/Inventarios/Categorias/CategoriasCRUD.vue'),
        },
        {
          path: 'modificadores',
          name: 'admin_modificadores',
          meta: { admin: true },
          component: () => import('../components/Inventarios/Modificadores/ModificadoresCRUD.vue'),
        },
        {
          path: 'productos',
          name: 'admin_productos',
          meta: { admin: true },
          component: () => import('../components/Inventarios/Productos/ProductosCrud.vue'),
        },
        {
          path: 'codigos-barra',
          name: 'codigos',
          meta: { admin: true },
          component: () => import('../components/Inventarios/CodigosBarra/GeneradorCodigos.vue'),
        },
        {
          path: 'servicios',
          name: 'admin_servicios',
          meta: { admin: true },
          component: () => import('../components/Inventarios/Servicios/ServiciosCrud.vue'),
        },
        {
          path: 'promociones',
          name: 'admin_promociones',
          meta: { admin: true },
          component: () => import('../components/Inventarios/Promociones/PromocionesCRUD.vue'),
        },
        {
          path: 'inventarios',
          name: 'admin_inventarios',
          meta: { admin: true },
          component: () => import('../components/Inventarios/invResources/inventariosCRUD.vue'),
        },
        {
          path: 'entradas',
          name: 'admin_entradas',
          meta: { admin: true },
          component: () => import('../components/Inventarios/RecepcionMercancias/DocumentosCRUD.vue'),
        },
        {
          path: 'documentoRecepcion/:idDocumento?',
          name: 'inventarios-documentos',
          meta: { admin: true },
          component: () => import('../components/Inventarios/RecepcionMercancias/DocumentosCreator.vue'),
        },
        {
          path: 'salidas',
          name: 'admin_salidas',
          meta: { admin: true },
          component: () => import('../components/Inventarios/SalidaMercancias/DocumentosSalidaCRUD.vue'),
        },
        {
          path: 'documentoSalida/:idDocumento?',
          name: 'inventarios-documentos-salida',
          meta: { admin: true },
          component: () => import('../components/Inventarios/SalidaMercancias/DocumentoSalidasCreator.vue'),
        },
        {
          path: 'reporteExistencias',
          name: 'repo_existencias',
          meta: { admin: true },
          component: () => import('../components/Inventarios/ReporteInventario/ReporteExistencias.vue'),
        },
        {
          path: 'reporte',
          name: 'repo_inventario',
          meta: { admin: true },
          component: () => import('../components/Inventarios/ReporteInventario/ReporteInventario.vue'),
        },
        {
          path: 'proveedores',
          name: 'proveedores_inventario',
          meta: { admin: true },
          component: () => import('../components/Inventarios/Proveedores/ProveedoresCRUD.vue'),
        },
        {
          path: 'transferencias',
          name: 'admin_transferencias',
          meta: { admin: true },
          component: () => import('../components/Inventarios/TransferenciaMercancias/DocumentosTransferCRUD.vue'),
        },
        {
          path: "documentoTransferencia/:idDocumento?",
          name: "inventarios-documentos-transferencia",
          props: (route) => ({
            idDocumento: route.params.idDocumento,
            deptoOrigen: route.query.deptoOrigen || null,
            almacenOrigen: route.query.almacenOrigen || null,
            deptoDestino: route.query.deptoDestino || null,
            almacenDestino: route.query.almacenDestino || null,
          }),
          meta: { admin: true },
          component: () => import("../components/Inventarios/TransferenciaMercancias/DocumentosTransferCreator.vue"),
        },
        {
          path: 'conteoMercancias',
          name: 'admin_conteo',
          meta: { admin: true },
          component: () => import('../components/Inventarios/ConteoMercancias/DocumentosConteoCRUD.vue'),
        },
        {
          path: 'conteo/:idDocumento?',
          name: 'inventarios-conteo',
          meta: { admin: true },
          component: () => import('../components/Inventarios/ConteoMercancias/Conteo.vue'),
        },
        {
          path: 'conteo-rapido',
          name: 'inventarios-conteo-rapido',
          meta: { admin: true },
          component: () => import('../components/Inventarios/ConteoMercancias/AjusteStock.vue'),
        },
        {
          path: 'documentoConteo/:idDocumento?',
          name: 'inventarios-documentos-conteo',
          meta: { admin: true },
          component: () => import(/* webpackChunkName: "about" */ '../components/Inventarios/ConteoMercancias/DocumentosConteoCreator.vue'),
        },
        {
          path: 'orden-compra-insumo',
          name: 'admin_orden_compra_insumo',
          meta: { admin: true },
          component: () => import('../components/Inventarios/OrdenesCompra/OrdenesCompraCRUDV1.vue'),
        },
        {
          path: 'orden-compra-presentacion',
          name: 'admin_orden_compra_presentacion',
          meta: { admin: true },
          component: () => import('../components/Inventarios/OrdenesCompra/OrdenesCompraCRUD.vue'),
        },
        {
          path: 'orden-compra-ideales',
          name: 'admin_orden_compra_ideales',
          meta: { admin: true },
          component: () => import('../components/Inventarios/OrdenesCompra/OrdenesIdeales.vue'),
        },
        {
          path: 'compras',
          name: 'admin_compra',
          meta: { admin: true },
          component: () => import('../components/Inventarios/Compras/ComprasCRUD.vue'),
        },
        {
          path: 'consumoPromedio',
          name: 'consumo_promedio',
          meta: { admin: true },
          component: () => import('../components/Inventarios/ReporteInventario/ConsumoPromedio.vue'),
        },
      ]
    },
    {
      path: '/documentoTransferencia/:idDocumento?',
      name: 'inventarios-documentos-transferenciaEditor',
      meta: { admin: true },
      component: () => import(/* webpackChunkName: "about" */ '../components/Inventarios/TransferenciaMercancias/DocumentosTransferCreator.vue'),
    },
    /* Zonas de impresion */
    {
      path: '/zonas-impresion',
      props: { type: 'zonas-impresion' },
      meta: { admin: true },
      component: () => import('../components/MainComponents/LandingVuetify.vue'),
      children: [
        {
          path: '/',
          name: 'zonasimpresion',
          meta: { admin: true },
          component: () => import('../components/ZonaImpresion/ZonasImpresionCRUD.vue'),
        },]
    },
    {
      path: '/comanda',
      name: 'comandaVirtual',
      meta: { admin: true },
      component: () => import('../components/Restaurante/Comanda/ComandaVirtual.vue'),
    },
    {
      path: '/balanceMonedero/:TENANT/:idCliente/:type?',
      name: 'MonderoBalanceCliente',
      meta: { publicRouter: true },
      component: () => import('../components/Clientes/Monedero/MonederoBalanceClient.vue'),
    },
    {
      path: '/productos-inventarios/promocionesEditor/:idPromocion?',
      name: 'inventarios-promocion-editor',
      meta: { admin: true },
      component: () => import('../components/Inventarios/Promociones/PromocionesCreator.vue'),
    },
  ]
})

router.beforeEach(async (to, from, next) => {
  router.loading = true;
  if (to.name == 'login') {
    let firebaseConf = new FirebaseConfig();
    firebaseConf.setTenantInLocal(to.params.tenant)
  }

  await store.dispatch('FirebaseApp/initFirebaseApp', null, { root: true })
  let configTenant = store.getters.getConfigTenant;
  if (configTenant && configTenant.Nombre) {
    document.title = `PGS | ${configTenant.Nombre}`;
  } else {
    document.title = "PGS";
  }

  const authRequired = to.matched.every(m => m.meta.publicRouter !== true);
  const user = await store.state.FirebaseApp.firebaseApp.auth.getCurrentUserFirstTime;
  if (user) {
    if (!store.state.FirebaseApp.firebaseApp.auth.getAuth(store.state.FirebaseApp.firebaseApp.mainApp).currentUser) {
      await store.state.FirebaseApp.firebaseApp.auth.getAuth(store.state.FirebaseApp.firebaseApp.mainApp).updateCurrentUser(user)
    }
    user.tokenResult = await user.getIdTokenResult();
    store.commit('setClaims', user)
    to.params.user = user;
  }

  if (to.name == 'login') {
    if (user) {
      next('/');
    }
  }

  if (user) {
    if (user.tokenResult.claims.Type == "Hotel") {
      if (to.meta.admin) {
        next('/');
      }
    }
  }



  if (authRequired && !user) {
    let firebase = new FirebaseConfig();
    next('/login/' + firebase.getTenantInLocal());
  }

  next();
})

router.afterEach(() => {
  router.loading = true;
})

export default router;
